
import CodePlayground from "../components/code-playground/codePlayground"

export default function PlaygroundPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <CodePlayground />
    </div>
  );
}
